import './styles/ResetPin.scss';
import { Fragment, useContext, useState, useEffect } from 'react';
import { AppContext } from '../../Context';
import { useHistory } from 'react-router';
import { MD5 } from 'crypto-js';

//components
import ToggleSlider from '../../components/ToggleSlider';

//classes
import MemberUser from '../../classes/memberUser';

//controllers
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';
import ClassController from '../../controllers/ClassController';

//mui icons
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { System_DeviceOrientationMap } from '../../assets/keyMap';

interface Props {

}

const ResetPin: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    //states form vars
    const [userPassword, SetUserPassword] = useState('');
    // const [newPassword, SetNewPassword] = useState('');
    const [enablePin, SetEnablePin] = useState<boolean>(false);
    const [newPin, SetNewPin] = useState('');
    const [retypePin, SetRetypePin] = useState('');
    const [visibilities, SetVisibilities] = useState([false, false, false] as boolean[]);
    //router objs
    const history = useHistory();

    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);
    const classController_memberUser = new ClassController('MemberUser');

    //watchers
    //watch for appContext.user.pinNumber update enablePin
    useEffect(() => {
        if(appContext.user.pin_number != '')
            SetEnablePin(true);
        else
            SetEnablePin(false);
    }, [appContext.user.pin_number]);

    //watch for databaseResultAction
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'updateUserPinNumber':
                        if (!JSON.stringify(res).includes('_false')) {
                            //update local user pin_number
                            const updatedPin = enablePin ? MD5(newPin).toString() : '';
                            const updatedMemberUser = classController_memberUser.SetPropertiesOfSubject(appContext.user, ['pin_number'], [updatedPin]);
                            appContext.SetUser(updatedMemberUser);

                            //update pin number on local storage
                            appContext.SetStorageRequestMode('set user');
                            appContext.SetStorageRequestParams([
                                ['user:pin_number', updatedPin]
                            ]);

                            appContext.SetPopupMessage('Pin number successfully saved!');
                            appContext.SetPopupButtons(['ok']);
                            appContext.SetPopupActions([() => { history.push('/Profile') }]);
                        } else if (JSON.stringify(res).includes('passwordUnmatched')) {
                            appContext.SetPopupMessage('Pin number not changed!\nThe user password is incorrect.');
                            ResetForm();
                        }
                        break;
                }
            }

            switch (appContext.databaseActionModeQueue[0]) {
                case 'updateUserPinNumber':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    const OnSubmitBtnClicked = () => {
        if (userPassword.length > 0) {
            if(enablePin) {
                if (newPin.length == 6 && newPin == retypePin) {
                    databaseInterfaceController.Queue('updateUserPinNumber', [
                        ['updateUserPinNumber', 'true'],
                        ['userID', appContext.user.userID],
                        ['password', userPassword],
                        ['newPin', newPin]
                    ]);
                } else {
                    if (newPin.length != 6) {
                        appContext.SetPopupMessage('Please enter 6-digits long pin number');
                    } else if (newPin != retypePin) {
                        appContext.SetPopupMessage('New Pin ans Retype Pin must be the same');
                    }
                }
            }  else {
                databaseInterfaceController.Queue('updateUserPinNumber', [
                    ['updateUserPinNumber', 'true'],
                    ['userID', appContext.user.userID],
                    ['password', userPassword],
                    ['newPin', '']
                ]);
            }
        } else {
            appContext.SetPopupMessage('You must provide your account password to make changes.');
        }
    }

    //exe functions
    const ResetForm = () => {
        SetUserPassword(''); SetNewPin(''); SetRetypePin(''); SetVisibilities([false, false, false]);
    }
    const FormatPin = (unformatted: string) => {
        return unformatted.replace(/[A-Za-z]/g, '').substring(0, 6);
    }

    return (
        <div className={'ResetPin ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            <div className='row-block'>
                <span className='row-note'>6-Digits Pin No. is used for quick verification login process.<br/>Pin No. login only available after user has login the app using password.</span>
                <span className='row-title'>Account Password</span>
                <div className='row-in-block'>
                    <input className='row-in' value={userPassword} type={visibilities[0] ? 'text' : 'password'} onChange={(e: any) => { SetUserPassword(e.target.value); }} placeholder='your user password' />
                    <button className='row-btn' onClick={() => SetVisibilities([!visibilities[0], visibilities[1], visibilities[2]])}>
                        {
                            visibilities[0] ?
                                <VisibilityIcon />
                                :
                                <VisibilityOffIcon />
                        }
                    </button>
                </div>
            </div>
            <div className='row-block'>
                <div className='row-toggle'>
                    <ToggleSlider labelA='Pin Disabled' labelB='Pin Enabled' toggled={enablePin} SetToggled={SetEnablePin} />
                </div>
            </div>
            {
                enablePin ?
                    <Fragment>
                        <div className='row-block'>
                            <span className='row-title'>New 6-digits pin</span>
                            <div className='row-in-block'>
                                <input className='row-in' value={newPin} type={visibilities[1] ? 'text' : 'password'} onChange={(e: any) => { SetNewPin(FormatPin(e.target.value)); }} placeholder='your new pin' />
                                <button className='row-btn' onClick={() => SetVisibilities([visibilities[0], !visibilities[1], visibilities[2]])}>
                                    {
                                        visibilities[1] ?
                                            <VisibilityIcon />
                                            :
                                            <VisibilityOffIcon />
                                    }
                                </button>
                            </div>
                        </div>
                        <div className='row-block'>
                            <span className='row-title'>Retype new pin</span>
                            <div className='row-in-block'>
                                <input className='row-in' value={retypePin} type={visibilities[2] ? 'text' : 'password'} onChange={(e: any) => { SetRetypePin(FormatPin(e.target.value)); }} placeholder='your new pin' />
                                <button className='row-btn' onClick={() => SetVisibilities([visibilities[0], visibilities[1], !visibilities[2]])}>
                                    {
                                        visibilities[2] ?
                                            <VisibilityIcon />
                                            :
                                            <VisibilityOffIcon />
                                    }
                                </button>
                            </div>
                        </div>
                    </Fragment>
                    :
                    <span className='pin-disabled-lbl'>6-Digits Pin No. is disabled, please enable it to start setup your pin number.</span>
            }
            <button className='submit-btn' onClick={() => OnSubmitBtnClicked()}>Save</button>
        </div>
    )
}
export default ResetPin;